import { FC } from "react";
import styled, { css } from "styled-components";

import Text from "@/components/Text";

const Badge = styled.div<{ $isExclusive: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 11px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  ${Text} {
    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    position: relative;
    color: ${({ theme }) => theme.colors.black};
  }
  svg {
    margin-right: 7px;
    color: ${({ theme }) => theme.colors.warning};
  }

  ${({ $isExclusive }) =>
    !$isExclusive &&
    css`
      background: ${({ theme }) => theme.colors.grayscaleLight};
      border-color: ${({ theme }) => theme.colors.grayscaleLight};

      ${Text} {
        color: ${({ theme }) => theme.colors.gray};
      }

      svg {
        color: ${({ theme }) => theme.colors.gray};
      }
    `}
`;

interface Props {
  className?: string;
  isExclusive: boolean;
}

const ExclusivityBadge: FC<Props> = ({ className, isExclusive }) => {
  return (
    <Badge className={className} $isExclusive={isExclusive}>
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M6 0.793457L7.80219 4.62173L12 5.15271L8.916 8.0497L9.7082 12.2061L6 10.1683L2.2918 12.2061L3.084 8.0497L0 5.15271L4.19781 4.62173L6 0.793457Z"
        />
      </svg>
      <Text $type="smallHeadline">
        {isExclusive ? "Exclusive" : "Non-Exclusive"}
      </Text>
    </Badge>
  );
};

export default ExclusivityBadge;
